export class Solicitacao{
    id: number;
    nomeUsuario: string;
    cpfSolicitacao: string;
    dataSolicitacao: string;
    idStatus: number;
    status: string;
    numeroPedido: string;
    pinUsuario: string;
    idUsuario: number; 
    idCertificadoComunicacao: number;
    codigoGrupo: string;
    codigoProduto: string;   
}